import { render } from "./ProfileContact.vue?vue&type=template&id=599e43ff"
import script from "./ProfileContact.vue?vue&type=script&lang=js"
export * from "./ProfileContact.vue?vue&type=script&lang=js"

import "./ProfileContact.vue?vue&type=style&index=0&id=599e43ff&lang=scss"

import exportComponent from "/builds/linkbuilding-crm/crm-v2-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__